import { Ability, AbilityBuilder } from '@casl/ability';
import { UserInfoWithLzPzus, UserRole } from 'api';

type TActions = 'manage' | 'update' | 'read' | 'create' | 'delete';
type TSubjects =
  | 'psa'
  | 'payment'
  | 'lz'
  | 'lzBusinessCard'
  | 'lzBusinessCardBlock'
  | 'lzBusinessCardEdit'
  | 'lzCreateMetalPrice'
  | 'lzeMetalPriceActionButtonBlock'
  | 'lzMetalTariffFavoriteEdit'
  | 'psaItemEdit'
  | 'psaPaymentButton'
  | 'psaViewDetailsButton'
  | 'pzuBusinessCard'
  | 'scan'
  | 'psaGetLzClients'
  | 'psaItemPrint'
  | 'createNewUser'
  | 'userEditButton'
  | 'userActivateButton'
  | 'pzuArchiveButton'
  | 'pzuCreateButton'
  | 'pzuInfoEditButton'
  | 'pzuBusinessCardCreate'
  | 'lzFieldIsVivsible'
  | 'agreementPrintVivsible'
  | 'getPzuAllowedUsers'
  | 'fromListButton'
  | 'getLzClients'
  | 'apiForm'
  | 'sberIdForm'
  | 'createNews'
  | 'getLzsDocument'
  | 'loadLzsDocument'
  | 'createButton'
  | 'selectPaymentsButton'
  | 'getBusinessCards'
  | 'getLzClientCards';

export type TAppAbility = Ability<[TActions, TSubjects]>;

export default function defineAbilityFor(user: UserInfoWithLzPzus | undefined) {
  const { can, cannot, build } = new AbilityBuilder<TAppAbility>(Ability);
  const userRole = user?.roles[0];

  // У нас политика запрещать управляему сущность, а потом где надо ее разрешать.
  // Кнопка создания Платежа на странице списка платежей
  cannot('manage', 'payment');
  // Кнопка редактирования ЛЗ
  cannot('manage', 'lz');
  // Кнопка создания нового USER'а
  can('create', 'createNewUser');
  // Кнопка создания нового USER'а
  can('update', 'userEditButton');
  //  Вывод кнопки запроса активации у USER
  can('manage', 'userActivateButton');
  //  Вывод кнопки архивации у PZU
  can('manage', 'pzuArchiveButton');
  //  Вывод кнопки создания PZU
  can('manage', 'pzuCreateButton');
  // Вывод кнопки создания бизнес-карты у ЛЗ
  cannot('manage', 'lzBusinessCard');
  // Вывод кнопки блокировкиАктивации бизнес-карты у ЛЗ
  cannot('manage', 'lzBusinessCardBlock');
  // Вывод кнопки редактирования бизнес-карты у ЛЗ
  cannot('manage', 'lzBusinessCardEdit');
  // Вывод кнопки создания тарифор у ЛЗ
  cannot('manage', 'lzCreateMetalPrice');
  // Вывод кнопок управления у тарифов
  cannot('manage', 'lzeMetalPriceActionButtonBlock');
  // Нажатие кнопки избранного тарифов у ЛЗ
  cannot('manage', 'lzMetalTariffFavoriteEdit');
  // Кнопка создания ПСА на странице списка пса
  cannot('manage', 'psa');
  // Вывод кнопки редактирование в пса
  cannot('manage', 'psaItemEdit');
  // Вывод кнопки оплаты в пса
  cannot('manage', 'psaPaymentButton');
  // Вывод кнопки просмотре платежа в пса
  cannot('manage', 'psaViewDetailsButton');
  // Вывод кнопки печати акта
  cannot('manage', 'psaItemPrint');
  // Запрос пользователей ЛЗ на странице просмотра ПСА
  can('manage', 'psaGetLzClients');
  // Вывод кнопок создания (привязки) бизнес-карты к ПЗУ на странице ПЗУ
  cannot('manage', 'pzuBusinessCard');
  // Вывод кнопок создания нового сотрудника ПЗУ
  can('create', 'pzuBusinessCard');
  // Вывод кнопки создания новой бизнес-карты
  can('create', 'pzuBusinessCardCreate');
  // Вывод кнопки редактирования информации о ПЗУ
  can('manage', 'pzuInfoEditButton');
  // Возможность работы со сканом
  cannot('manage', 'scan');
  // Возможность работы со сканом
  can('manage', 'lzFieldIsVivsible');
  // Вывод кнопки соглашения о персональных данных
  can('manage', 'agreementPrintVivsible');
  // Вывод кнопок для добавления сотрудников ПЗУ
  cannot('manage', 'getPzuAllowedUsers');
  // Вывод кнопок Из списка
  can('manage', 'fromListButton');
  // Запрос lz-clients на странице просмотра ПСА
  can('manage', 'getLzClients');
  // Возможность видеть API шлюз при редактировании
  can('read', 'apiForm');
  // Возможность видеть СберID форму при редактировании
  can('read', 'sberIdForm');
  // Вывод кнопки для создания новости
  cannot('create', 'createNews');
  // Возможность получать документ
  cannot('read', 'getLzsDocument');
  // Возможность загружать\удалять документ
  cannot('create', 'loadLzsDocument');
  // Вывод кнопки создания в навбвре
  can('create', 'createButton');
  // Вывод кнопки выбора нескольких ПСА для оплаты
  cannot('create', 'selectPaymentsButton');
  // Получение бизнесс карт
  cannot('read', 'getBusinessCards');
  // Получение карт LzClient
  cannot('read', 'getLzClientCards');

  if (userRole === UserRole.AppAdmin) {
    can('update', 'lz');
    can('update', 'psaViewDetailsButton');
    cannot('manage', 'psaGetLzClients');
    cannot('manage', 'agreementPrintVivsible');
    can('manage', 'getPzuAllowedUsers');
    cannot('manage', 'getLzClients');
    cannot('manage', 'fromListButton');
    cannot('create', 'pzuBusinessCardCreate');
    cannot('create', 'pzuBusinessCard');
    can('create', 'createNews');
    can('read', 'scan');
    can('read', 'getLzsDocument');
    can('create', 'loadLzsDocument');
    can('update', 'lzBusinessCardBlock');
  }
  if (userRole === UserRole.LzAdmin) {
    can('update', 'lz');
    can('create', 'psa');
    can('create', 'psa');
    can('create', 'lzBusinessCard');
    can('update', 'lzBusinessCardBlock');
    can('update', 'lzBusinessCardEdit');
    can('create', 'lzCreateMetalPrice');
    can('update', 'lzeMetalPriceActionButtonBlock');
    can('create', 'payment');
    can('update', 'psaItemEdit');
    can('update', 'psaPaymentButton');
    can('update', 'psaViewDetailsButton');
    can('create', 'pzuBusinessCard');
    can('create', 'scan');
    can('delete', 'scan');
    can('read', 'scan');
    can('create', 'psaItemPrint');
    can('delete', 'pzuBusinessCard');
    can('update', 'lzMetalTariffFavoriteEdit');
    cannot('read', 'lzFieldIsVivsible');
    can('manage', 'getPzuAllowedUsers');
    cannot('read', 'apiForm');
    cannot('read', 'sberIdForm');
    can('read', 'getLzsDocument');
    can('create', 'loadLzsDocument');
    can('create', 'selectPaymentsButton');
    can('read', 'getBusinessCards');
    can('read', 'getLzClientCards');
  }
  if (userRole === UserRole.PzuCashier) {
    can('create', 'psa');
    can('create', 'payment');
    can('update', 'psaItemEdit');
    can('update', 'psaPaymentButton');
    can('update', 'psaViewDetailsButton');
    can('create', 'pzuBusinessCard');
    can('create', 'scan');
    can('delete', 'scan');
    can('read', 'scan');
    can('create', 'psaItemPrint');
    can('read', 'getBusinessCards');
    can('read', 'getLzClientCards');
  }
  if (userRole === UserRole.PzuInspector) {
    can('create', 'psa');
    can('update', 'psaItemEdit');
    can('update', 'psaPaymentButton');
    can('create', 'scan');
    can('delete', 'scan');
    can('read', 'scan');
    can('create', 'psaItemPrint');
    can('read', 'getBusinessCards');
    can('read', 'getLzClientCards');
  }

  if (userRole === UserRole.LzAccountant) {
    cannot('create', 'createNewUser');
    cannot('update', 'userEditButton');
    cannot('manage', 'userActivateButton');
    cannot('manage', 'pzuArchiveButton');
    cannot('manage', 'pzuCreateButton');
    cannot('manage', 'pzuInfoEditButton');
    cannot('create', 'pzuBusinessCardCreate');
    can('create', 'scan');
    can('read', 'scan');
    can('create', 'psaItemPrint');
    can('manage', 'psaViewDetailsButton');
    cannot('create', 'pzuBusinessCard');
    cannot('manage', 'fromListButton');
    cannot('create', 'createButton');
    can('read', 'getBusinessCards');
  }

  if (userRole === UserRole.AppViewer) {
    cannot('manage', 'getLzClients');
    cannot('manage', 'agreementPrintVivsible');
    cannot('manage', 'fromListButton');
    cannot('manage', 'pzuInfoEditButton');
    cannot('manage', 'pzuArchiveButton');
    can('read', 'scan');
    can('create', 'psaItemPrint');
    can('read', 'getLzsDocument');
    cannot('create', 'createButton');
    can('create', 'loadLzsDocument');
  }

  if (userRole === UserRole.TechSupport) {
    can('update', 'lz');
    can('update', 'psaViewDetailsButton');
    cannot('manage', 'psaGetLzClients');
    cannot('manage', 'agreementPrintVivsible');
    can('manage', 'getPzuAllowedUsers');
    cannot('manage', 'getLzClients');
    cannot('manage', 'fromListButton');
    cannot('create', 'pzuBusinessCardCreate');
    cannot('create', 'pzuBusinessCard');
    can('create', 'createNews');
    can('read', 'scan');
    can('read', 'getLzsDocument');
    can('create', 'loadLzsDocument');
    can('update', 'lzBusinessCardBlock');
    cannot('create', 'createNewUser');
  }

  return build();
}
